<template>
	<div>
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="60%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-tabs v-model="activeName" type="card" style="max-height:580px;">
					<el-tab-pane label="源数据解析" name="analysisTab" v-if="companyInfoPlatformKV">
						<el-form ref="sourceForm" :model="sourceForm" label-width="120px" :rules="rules">
							<el-form-item label="数据来源" prop="platformId">
								<el-select v-model="sourceForm.platformId" placeholder="请选择数据来源" filterable @change="platformIdChange">
									<el-option key="" label="请选择数据来源" value=""></el-option>
									<el-option v-for="item in companyInfoPlatformKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
								</el-select>&nbsp;<el-button type="primary" icon="el-icon-refresh" v-prevent-re-click @click="analysisData">解析</el-button>
							</el-form-item>
							<el-form-item label="源数据" prop="data">
								<el-input type=textarea :rows=18 v-model="sourceForm.data"> </el-input>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="公司信息" name="baseTab">
						<el-row>
							<el-col :span="12">
								<el-form-item label="公司名称" prop="name">
									<el-input v-model="form.name"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="社会信用代码" prop="taxNo">
									<el-input v-model="form.taxNo"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="所在区域" prop="cityId">
							<el-row>
								<el-col :span="18">
									<el-select v-model="form.provinceId" placeholder="请选择省" filterable @change="provinceChange">
										<el-option key="" label="请选择省" value=""></el-option>
										<el-option v-for="item in provinceKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>&nbsp;
									<el-select v-model="form.cityId" placeholder="请选择城市" filterable @change="cityChange">
										<el-option key="" label="请选择城市" value=""></el-option>
										<el-option v-for="item in cityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>&nbsp;
									<el-select v-model="form.areaId" placeholder="请选择区域" filterable>
										<el-option key="" label="请选择区域" value=""></el-option>
										<el-option v-for="item in areaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-col>
								<el-col :span="6">
									<el-form-item label="级别" prop="level">
										<el-select v-model="form.level" placeholder="请选择级别">
											<el-option v-for="item in levelKV" :key=item.key :label="item.value" :value=item.key></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form-item>
						<el-row>
							<el-col :span="8">
								<el-form-item label="法定代表人" prop="legalPerson">
									<el-input v-model="form.legalPerson"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="成立日期" prop="establishDate"> 
									<el-date-picker
										type="date"
										placeholder="成立日期"
										v-model="form.establishDate"
										value-format="yyyy-MM-dd"
									></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="社保人数" prop="socialSecurityNum">
									<el-input v-model="form.socialSecurityNum"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="货币类型">
									<el-select v-model="form.capitalType" placeholder="请选择区域" filterable>
										<el-option key="人民币" label="人民币" value="人民币"></el-option>
										<el-option key="美元" label="美元" value="美元"></el-option>
										<el-option key="香港元" label="香港元" value="香港元"></el-option>
										<el-option key="日元" label="日元" value="日元"></el-option>
										<el-option key="欧元" label="欧元" value="欧元"></el-option>
										<el-option key="澳门元" label="澳门元" value="澳门元"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="注册资本(万)" prop="registeredCapital"> 
									<el-input v-model="form.registeredCapital"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="实缴资本(万)" prop="realCapital">
									<el-input v-model="form.realCapital"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="资源类型" prop="resourcesType"> 
									<el-select v-model="form.resourcesType" placeholder="请选择资源类型" filterable>
										<el-option key="" label="请选择资源类型"></el-option>
										<el-option v-for="item in customerTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="分析规则" prop="ruleId">
									<el-select v-model="form.ruleId" placeholder="请选择分析规则">
										<el-option key="" label="请选择分析规则" value=""></el-option>
										<el-option v-for="item in ruleKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="网址" prop="website">
									<el-input v-model="form.website"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="16">
								<el-form-item label="地址" prop="address">
									<el-input v-model="form.address"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="公司状态" prop="companyStatus">
									<el-input v-model="form.companyStatus"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="经营范围" prop="businessScope">
							<el-input type=textarea :rows=4 v-model="form.businessScope"> </el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="股东信息" name="shareholderTab">
						<el-table
							:data="shareholders"
							border
							class="table"
							ref="multipleTable"
							header-cell-class-name="table-header"
							:cell-style="{padding:4+'px'}"
							size="medium"
							stripe
						>
							<el-table-column type="index" width="50"></el-table-column>
							<el-table-column prop="name" label="股东名称"></el-table-column>
							<el-table-column prop="contributionRatio" label="持股比例"></el-table-column>
							<el-table-column prop="position" label="认缴出资额"></el-table-column>
							<el-table-column prop="subscriptionDate" label="认缴出资日期"></el-table-column>
							<el-table-column label="操作" width="180" align="center" v-if="!form.trackerId || form.trackerId == form.createBy">
								<template slot-scope="scope">
									<el-button
										type="text"
										icon="el-icon-delete"
										class="red"
										@click="handleDelete(0, scope.$index, scope.row)"
									>删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-button
							type="text"
							icon="el-icon-lx-add"
							@click="handleAddShareholder"
							style="font-size:14px"
						>添加内容</el-button>
					</el-tab-pane>
					<el-tab-pane label="主要人员" name="keyMemberTab">
						<el-table
							:data="keyMembers"
							border
							class="table"
							ref="multipleTable"
							header-cell-class-name="table-header"
							:cell-style="{padding:4+'px'}"
							size="medium"
							stripe
						>
							<el-table-column type="index" width="50"></el-table-column>
							<el-table-column prop="name" label="姓名"></el-table-column>
							<el-table-column prop="position" label="职务"></el-table-column>
							<el-table-column prop="contributionRatio" label="持股比例"></el-table-column>
							<el-table-column label="操作" width="180" align="center" v-if="!form.trackerId || form.trackerId == form.createBy">
								<template slot-scope="scope">
									<el-button
										type="text"
										icon="el-icon-delete"
										class="red"
										@click="handleDelete(1, scope.$index, scope.row)"
									>删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-button
							type="text"
							icon="el-icon-lx-add"
							@click="handleAddKeyMember"
							style="font-size:14px"
						>添加内容</el-button>
					</el-tab-pane>
					<el-tab-pane label="联系方式" name="contactTab">
						<div style="max-height: 360px; overflow: auto; ">
							<el-table
								:data="contacts"
								border
								class="table"
								ref="multipleTable"
								header-cell-class-name="table-header"
								:cell-style="{padding:4+'px'}"
								size="medium"
								stripe
							>
								<el-table-column type="index" width="50"></el-table-column>
								<el-table-column prop="contactType" label="类型" :formatter="contactTypeFormat"></el-table-column>
								<el-table-column prop="contactInfo" label="号码"></el-table-column>
								<el-table-column prop="name" label="联系人"></el-table-column>
								<el-table-column prop="platforms" label="来源"></el-table-column>
								<el-table-column label="操作" width="180" align="center" v-if="!form.trackerId || form.trackerId == form.createBy">
									<template slot-scope="scope">
										<el-button
											type="text"
											icon="el-icon-delete"
											class="red"
											@click="handleDelete(2, scope.$index, scope.row)"
										>删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-button
							type="text"
							icon="el-icon-lx-add"
							@click="handleAddContact"
							style="font-size:14px"
						>添加内容</el-button>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="添加股东信息" :visible.sync="shareholderVisible" width="40%">
			<el-form ref="shareholderForm" :model="shareholderForm" label-width="120px" :rules="memberRules">
				<el-form-item label="名称" prop="name">
					<el-input v-model="shareholderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="持股比例" prop="contributionRatio">
					<el-input v-model="shareholderForm.contributionRatio"></el-input>
				</el-form-item>
				<el-form-item label="认缴出资额" prop="position">
					<el-input v-model="shareholderForm.position"></el-input>
				</el-form-item>
				<el-form-item label="认缴出资日期" prop="subscriptionDate">
					<el-date-picker
						type="date"
						placeholder="认缴出资日期"
						v-model="shareholderForm.subscriptionDate"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="shareholderVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveShareholder" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="添加主要人员" :visible.sync="keyMemberVisible" width="40%">
			<el-form ref="keyMemberForm" :model="keyMemberForm" label-width="120px" :rules="memberRules">
				<el-form-item label="名称" prop="name">
					<el-input v-model="keyMemberForm.name"></el-input>
				</el-form-item>
				<el-form-item label="职务" prop="position">
					<el-input v-model="keyMemberForm.position"></el-input>
				</el-form-item>
				<el-form-item label="持股比例" prop="contributionRatio">
					<el-input v-model="keyMemberForm.contributionRatio"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="keyMemberVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveKeyMember" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="添加联系人信息" :visible.sync="contactVisible" width="40%">
			<el-form ref="contactForm" :model="contactForm" label-width="120px" :rules="contactRules">
				<el-form-item label="类型" prop="contactType"> 
					<el-select v-model="contactForm.contactType" placeholder="请选择类型" filterable>
						<el-option key="" label="请选择类型"></el-option>
						<el-option v-for="item in contactTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系人" prop="name">
					<el-input v-model="contactForm.name"></el-input>
				</el-form-item>
				<el-form-item label="号码" prop="contactInfo">
					<el-input v-model="contactForm.contactInfo"></el-input>
				</el-form-item>
				<el-form-item label="来源" prop="platforms">
					<el-input v-model="contactForm.platforms"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="contactVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveContact" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
	</div>
</template>

<script>
import {savePotentialResources, getAreaKv, getPotentialResourcesPlatform} from '../../api/index';
import bus from './bus';
export default {
    name: 'PotentialResourcesEdit',
    data() {
        return {
			label_style: {
				'width': "150px",
				'word-break': 'keep-all'
			},
			content_style: {
				'min-width': '200px',
				'word-break': 'break-all' //过长时自动换行
			},
			dataSource:[],
			editVisible:false,
			activeName:"baseTab",
			shareholders:[],
			keyMembers:[],
			contacts:[],
			form:{},
			provinceKV:{},
			cityKV:{},
			areaKV:{},
			ruleKV:{},
			sourceKV:{},
			shareholderForm:{},
			shareholderVisible:false,
			keyMemberForm:{},
			keyMemberVisible:false,
			contactForm:{},
			contactVisible:false,
			companyInfoPlatformKV:[],
			sourceForm:{},
			title:"",
			platformRegs:[],
			currentPlatformId:undefined,
			capitalType:['美元','香港元','日元','欧元','澳门元'],
			rules: {
                name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
				taxNo: [{ required: true, message: '社会信用代码不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '请选择所在区域', trigger: 'blur' }],
				legalPerson: [{ required: true, message: '法人代表不能为空', trigger: 'blur' }],
				establishDate: [{ required: true, message: '请选择成立日期', trigger: 'blur' }],
				registeredCapital: [{ required: true, message: '注册资本不能为空', trigger: 'blur' }],
				address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
				businessScope: [{ required: true, message: '经营范围不能为空', trigger: 'blur' }],
				ruleId: [{ required: true, message: '请选择适用的分析规则', trigger: 'blur' }]
            },
			memberRules: {
				name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
			},
			contactRules: {
				contactType: [{ required: true, message: '请选择类型', trigger: 'blur' }],
				contactInfo: [{ required: true, message: '号码不能为空', trigger: 'blur' }],
				platforms: [{ required: true, message: '来源不能为空', trigger: 'blur' }]
			},
			levelKV:[{"key":0, "value":"普通"}, {"key":1, "value":"重点"}],
			customerTypeKV:[{"key":0,"value":"元器件生产商"},{"key":1,"value":"元器件经销商"},{"key":2,"value":"设备生产商"},{"key":3,"value":"设备经销商"},{"key":4,"value":"未知生产商"},{"key":5,"value":"未知经销商"}],
			contactTypeKV:[{"key":0,"value":"手机"},{"key":1,"value":"固定电话"},{"key":2,"value":"QQ"},{"key":3,"value":"邮箱"},{"key":4,"value":"微信"},{"key":5,"value":"其他"}]
		};
    },
    methods: {
		setDatasource(data, title, provinceKV, ruleKV, companyInfoPlatformKV, sourceKV) {
			this.title = title;
			this.provinceKV = provinceKV;
			this.sourceKV = sourceKV;
			this.ruleKV = ruleKV;
			this.companyInfoPlatformKV = companyInfoPlatformKV
			this.activeName = "baseTab";
			this.sourceForm = {};
			this.currentPlatformId = undefined;
			this.buildData(data);
			this.editVisible = true;
		},
		buildData(data) {
			if (data != undefined) {
				this.form = data;
				if (data.provinceId != undefined) {
					this.getAreaKV(data.provinceId, 1);
					if (data.cityId != undefined) {
						this.getAreaKV(data.cityId, 2);
					}
				}
				this.shareholders = data["shareholders"];
				this.keyMembers = data["keyMembers"];
				this.contacts = [];
				if ("contacts" in data && data["contacts"].length > 0) {
					this.contacts = this.contacts.concat(data["contacts"]);
				}
				if ("mobiles" in data && data["mobiles"].length > 0) {
					this.contacts = this.contacts.concat(data["mobiles"]);
				}
				if ("tels" in data && data["tels"].length > 0) {
					this.contacts = this.contacts.concat(data["tels"]);
				}
				if ("qqs" in data && data["qqs"].length > 0) {
					this.contacts = this.contacts.concat(data["qqs"]);
				}
				if ("mails" in data && data["mails"].length > 0) {
					this.contacts = this.contacts.concat(data["mails"]);
				}
				if ("wechats" in data && data["wechats"].length > 0) {
					this.contacts = this.contacts.concat(data["wechats"]);
				}
				if ("others" in data && data["others"].length > 0) {
					this.contacts = this.contacts.concat(data["others"]);
				}
			} else {
				this.form = {};
				this.$set(this.form, "level", 0);
				this.shareholders = [];
				this.keyMembers = [];
				this.contacts = [];
			}
		},
		//联系类型
		contactTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.contactTypeKV.length; i++) {
				if (this.contactTypeKV[i].key === cellValue){
					return this.contactTypeKV[i].value;
				}
			}
			return " - ";
		},
		// 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let members = [];
					members = members.concat(this.shareholders);
					members = members.concat(this.keyMembers);
					this.form["members"] = members;
					this.form["contacts"] = this.contacts;
					if (this.currentPlatformId != undefined) {
						this.form["platformId"] = this.currentPlatformId;
					}
					savePotentialResources(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								bus.$emit('potential-resources-change', this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		provinceChange(value) {
			this.$set(this.form, 'cityId', '');
			this.areaKV = [];
			this.cityKV = [];
			if (value == "") return;
			this.getAreaKV(value, 1);
		},
		cityChange(value) {
			this.areaKV = [];
			this.$set(this.form, 'areaId', '');
			if (value == "") return;
			this.getAreaKV(value, 2);
		},
		//获取省市区
		getAreaKV(parentId, type) {
			getAreaKv(parentId).then(res => {
				if (res.code == 0 ) {
					if (type == 0) {
						this.provinceKV = res.data;
					} else if (type == 1){
						this.cityKV = res.data;
					} else if (type == 2){
						this.areaKV = res.data;
					} else if (type == 3){
						this.queryCityKV = res.data;
					} else if (type == 4){
						this.queryAreaKV = res.data;
					}
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		// 删除操作
        handleDelete(type, index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let kv = (type==0?this.shareholders:(type==1?this.keyMembers:this.contacts));
					let idx = kv.findIndex(item => {
						if (type == 2 && item.contactType === row.contactType && item.contactInfo === row.contactInfo) {
							return true;
						} else if (type < 2 && item.name === row.name) {
							return true;
						}
					}); 
					if (idx === -1) return;
					kv.splice(idx, 1);
                })
                .catch(() => {});
        },
		handleAddShareholder() {
			this.shareholderForm = {};
			this.shareholderVisible = true;
		},
		handleAddKeyMember() {
			this.keyMemberForm = {};
			this.keyMemberVisible = true;
		},
		handleAddContact() {
			this.contactForm = {};
			this.contactVisible = true;
		},
		saveShareholder() {
			this.$refs.shareholderForm.validate(valid => {
				if (valid) {
					this.shareholderForm["memberType"] = 0;
					this.shareholders.push(JSON.parse(JSON.stringify(this.shareholderForm)));
					this.shareholderVisible = false;
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		saveKeyMember() {
			this.$refs.keyMemberForm.validate(valid => {
				if (valid) {
					this.keyMemberForm["memberType"] = 1;
					this.keyMembers.push(JSON.parse(JSON.stringify(this.keyMemberForm)));
					this.keyMemberVisible = false;
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		saveContact() {
			this.$refs.contactForm.validate(valid => {
				if (valid) {
					this.contacts.push(JSON.parse(JSON.stringify(this.contactForm)));
					this.contactVisible = false;
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		platformIdChange(value){
			if (value == undefined || value == "") {
				this.platformRegs = [];
				return;
			}
			getPotentialResourcesPlatform(value).then(res => {
				if (res.code == 0) {
					this.platformRegs = res.data.rule;
				} else {
					this.$message.error(`获取企业信息平台信息失败！` + res.message);
				}
			});
		},
		analysisData() {
			if(this.sourceForm.platformId == undefined || this.sourceForm.platformId == "") {
				this.$message.error(`请选择数据来源！`);
				return;
			}
			if (this.sourceForm.data == undefined || this.sourceForm.data == "") {
				this.$message.error(`请输入需要解析的内容！`);
				return;
			}
			this.currentPlatformId = this.sourceForm.platformId;
			let platformRegs = JSON.parse(this.platformRegs);
			let targetData = {}
			for (let i = 0; i < platformRegs.length; i++) {
				let reg = new RegExp(platformRegs[i]["reg"]);
				let target = undefined;
				
				let joinStr = "";
				let targetMatchDatas = [];
			
				if ("name" in platformRegs[i]) {
					target = platformRegs[i]["name"];
					let regAll = new RegExp(platformRegs[i]["reg"], "gm");
					let matchDatas = this.sourceForm["data"].match(regAll);
					for (var j = 0; j < matchDatas.length; j++) {
						let result = reg.exec(matchDatas[j]);
						if (result) {
							let targetForm = {};
							if ("supplement" in platformRegs[i]) {
								for(var key in platformRegs[i]["supplement"]) {
									targetForm[key] = platformRegs[i]["supplement"][key];
								}
							}
							for (var key in result.groups) {
								this.$set(targetForm, key, result.groups[key]); 
							}	
							if ("join" in platformRegs[i]) {
								let key = platformRegs[i]["join"];
								if (joinStr == "") {
									joinStr = targetForm[key];
								} else {
									joinStr = joinStr + "," + targetForm[key];
								}
							} else {
								targetMatchDatas.push(targetForm);
							}
						}
					}
					this.$set(targetData, target, "join" in platformRegs[i]?joinStr:targetMatchDatas);
				} else {
					let result = reg.exec(this.sourceForm["data"]);
					if (result) {
						for (var key in result.groups) {
							this.$set(targetData, key, result.groups[key]); 
						}	
					}
				}
			}
			
			let contacts = [];
			let platforms = this.getPlatformName(this.sourceForm.platformId);
			let mobileReg = new RegExp("^1[3-9]\\d{9}$");
			
			for (var key in targetData) {
				if (key == "areaInfo") {
					let areaInfo = targetData[key];
					if (!areaInfo) {
						continue;
					}
					areaInfo = areaInfo.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').trim();
					let indexOf = areaInfo.indexOf('省');
					let province = areaInfo.substring(0, indexOf + 1);
					areaInfo = areaInfo.substring(indexOf + 1, areaInfo.length);
					let provinceId = this.getAreaInfoId(this.provinceKV, province);
					if (provinceId){
						this.$set(targetData, "provinceId", provinceId); 
						getAreaKv(provinceId).then(res => {
							if (res.code == 0) {
								this.cityKV = res.data;
								indexOf = areaInfo.indexOf('市');
								let city = areaInfo.substring(0,  indexOf + 1);
								let cityId = this.getAreaInfoId(this.cityKV, city);
								if (cityId) { 
									this.$set(targetData, "cityId", cityId); 
									getAreaKv(cityId).then(res => {
										if (res.code == 0) {
											this.areaKV = res.data;
											let area = areaInfo.substring(indexOf + 1, areaInfo.length);
											let areaId = this.getAreaInfoId(this.areaKV, area);
											if (areaId) {
												this.$set(targetData, "areaId", areaId);
											}
										} else {
											this.$message.error("获取区域信息失败！" + res.message);
										}
									})
								}	
							} else {
								this.$message.error("获取区域信息失败！" + res.message);
							}
						})			
					}
				} else if (key.endsWith("Capital")){
					let capital = targetData[key];
					if (!capital) {
						continue;
					}
					capital = capital.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').trim();
					if (key == "registeredCapital") {
						let i = 0;
						for(; i < this.capitalType.length; i++) {
							if (capital.indexOf(this.capitalType[i]) > -1) {
								this.$set(targetData, 'capitalType', this.capitalType[i]);
								break;
							}
						}
						if (i == this.capitalType.length) {
							this.$set(targetData, 'capitalType', '人民币');
						}
					}
					capital = /[0-9.,]*/.exec(capital);
					if (capital) {
						let money = capital[0];
						this.$set(targetData, key, money.replaceAll(',', ''));
					}
				} else if (key.endsWith("Date") || key.endsWith("tel") || key.endsWith("mail") || key.endsWith("address") || key == "website"){
					let value = targetData[key];
					if (!value) {
						continue;
					}
					if (value.indexOf('暂无') == -1) {
						value = value.replaceAll('\n', '').replaceAll(' ', '').trim();
						this.$set(targetData, key, value);
					}
					if (key.endsWith("tel")) {
						let tels = value.split(",");
						let contact = {}
						for (let i = 0; i < tels.length; i++) {
							contact["contactType"] = mobileReg.test(tels[i])?0:1;
							contact["contactInfo"] = tels[i];
							contact["name"] = "";
							contact["platforms"] = platforms;
							contacts.push(contact);
						}
					}
					if (key.endsWith("mail")) {
						let mails = value.split(",");
						let contact = {}
						for (let i = 0; i < mails.length; i++) {
							contact["contactType"] = 3;
							contact["contactInfo"] = mails[i];
							contact["name"] = "";
							contact["platforms"] = platforms;
							contacts.push(contact);
						}
					}
				} else if (key == "socialSecurityNum") {
					let value = targetData[key];
					this.$set(targetData, key, value.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').replaceAll('人', '').trim());
				} else {
					let value = targetData[key];
					if (!value) {
						continue;
					}
					if (typeof value != "string") {
						continue;
					}
					this.$set(targetData, key, value.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').trim());
				}
			}
			targetData["contacts"] = contacts;
			this.buildData(targetData);
			this.activeName = "baseTab";
		},
		getAreaInfoId(sourceKV, cellValue) {
			for (var i = 0; i < sourceKV.length; i++) {
				if (sourceKV[i].value === cellValue){
					return sourceKV[i].key;
				}
			}
			return undefined;
		},
		getPlatformName(key) {
			for (var i = 0; i < this.companyInfoPlatformKV.length; i++) {
				if (this.companyInfoPlatformKV[i].key === key){
					return this.companyInfoPlatformKV[i].value;
				}
			}
			return "";
		}
    }
};
</script>
<style>
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
</style>
<style scoped>
  /deep/ .el-card__header {
    padding: 12px 12px;
    font-size: 14px;
	color:#E6A23C;
	background-color:#F2F6FC;
  }

  /deep/ .el-card__body {
    padding-left:15px;
	padding-right:15px;
	padding-bottom:20px;
	
  }
  
  .card-content {
	padding-top:10px;
	padding-bottom:5px;
	border-bottom:#E4E7ED solid 1px;
	white-space: nowrap;  
    overflow: hidden;  
    text-overflow: ellipsis;  
    max-width: 200px;
  }
  
  .card-content span{
	color:#909399;
  }
</style>